import { apiGetAuth, apiPutAuth } from '@/utils/api'
import { API_CONFIGURATION } from '@/utils/api-url'

const state = {
  detail_pml_multiplier: {},
  data_modal_add_edit: {},
  modal_info: {
    isOpen: false,
    title: 'Perubahan Berhasil',
    description: 'Data Anda telah berhasil diubah',
    buttonTitle: 'Mengerti'
  },
  toggle_modal_add_edit_discard: {
    targetModals: false,  
    title: '',
    description: '',
    type: '',
    customTitleBtnOk: '',
    customTitleBtnCancel: '',
    customClass: '',
    loadingTable: false,
    loadingPopUp: false
  }
}

const mutations = {
  "SET_DETAIL_PML_MULTIPLIER": (state, payload) => {
    state.detail_pml_multiplier = payload
  },
  "SET_DATA_MODAL_ADD_EDIT": (state, payload) => {
    state.data_modal_add_edit = payload
  },
  "SET_MODAL_INFO": (state, payload) => {
    state.modal_info = payload
  },
  "SET_TOGGLE_MODAL_ADD_EDIT_DISCARD": (state, payload) => {
    state.toggle_modal_add_edit_discard = payload
  }
}

const actions = {
  async getDetailConfiguration(context, payload) {
    try {
      const response = await apiGetAuth(API_CONFIGURATION?.LIST, payload)
      return response?.data
    } catch (error) {
      return error
    }
  },
  async getDetailPmlMultiplier(context, payload) {
    try {
      const response = await apiGetAuth(API_CONFIGURATION.PML_PERCENTAGE_MULTIPLIER, payload)
      context.commit('SET_DETAIL_PML_MULTIPLIER', response?.data?.data?.data)
    } catch (error) {
      return error
    }
  },
  async updateDetailConfiguration(context, payload) {
    try {
      const response = await apiPutAuth(API_CONFIGURATION.BY_ID(payload?.id), payload?.reqBody)
      return response?.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      if (error?.response?.data?.status == 406) {
        const modalInfo = {
          isOpen: true,
          title: 'Mohon maaf',
          description: 'pengurangan nilai Jaminan Hari Tua (JHT) & Jaminan Pensiun (JP) tidak dapat dilakukan karena tindakan tersebut akan berdampak pada perhitungan yang telah disusun.',
          buttonTitle: 'Mengerti'
        }
        context.commit('SET_MODAL_INFO', modalInfo)
        return null
      } else {
        throw error
      }
    }
  }
}

const getters = {
  get_detail_pml_multiplier: state => {
    return state.detail_pml_multiplier
  },
  get_data_modal_add_edit: state => {
    return state.data_modal_add_edit
  },
  get_modal_info: state => {
    return state.modal_info
  },
  get_toggle_modal_add_edit_discard: state => {
    return state.toggle_modal_add_edit_discard
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
